<template>
  <svg :x="x" :y="y" viewBox="0 0 580 460">
    <slot>
      <g v-html="path"></g>
    </slot>
  </svg>
</template>

<script>
  import _ from 'underscore'

  export default {
    name: 'svg-picture',
    props: ['path', 'part'],
    data () {
      return {
        x: false,
        y: false,
      }
    },
    computed: {

    }
  }
</script>
